export class EndpointBotLinkModel {
  _id?: any;
  uuid: string;
  endpoint_uuid: string;
  bot_uuid: string;
  link_type: string;
  revision: string;
  status: string;
  vrsn: string;
  create_date?: Date;
  update_date?: Date;
  created_by?: string;
  updated_by?: string;
}
